import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Data,
    NavigationEnd,
    Router,
} from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { LocalStorageService, LOCAL_STORAGE_KEY } from './localstorage.service';
export interface Breadcrumb {
    label: string;
    url: string;
}

@Injectable({
    providedIn: 'root',
})
export class BreacdcrumService {
    // Subject emitting the breadcrumb hierarchy
    private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

    // Observable exposing the breadcrumb hierarchy
    readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService
    ) {
        const breadcrumbs = (
            this.localStorageService.getObject<Breadcrumb[]>(
                LOCAL_STORAGE_KEY.BREADRUMB
            ) || []
        ).filter(
            (value, index, self) =>
                index ===
                self.findIndex(
                    (t) => t.url === value.url && t.label === value.label
                )
        );
        this._breadcrumbs$.next(breadcrumbs);
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
                const root = this.router.routerState.snapshot.root;
                let breadcrumbs: Breadcrumb[] = [];
                this.addBreadcrumb(root, [], breadcrumbs);
                this.localStorageService.setObject(
                    LOCAL_STORAGE_KEY.BREADRUMB,
                    breadcrumbs
                );
                breadcrumbs = breadcrumbs.filter(
                    (value, index, self) =>
                        index ===
                        self.findIndex(
                            (t) =>
                                t.url === value.url && t.label === value.label
                        )
                );
                this._breadcrumbs$.next(breadcrumbs);
            });
    }

    private addBreadcrumb(
        route: ActivatedRouteSnapshot,
        parentUrl: string[],
        breadcrumbs: Breadcrumb[]
    ) {
        if (route) {
            // Construct the route URL
            const routeUrl = parentUrl.concat(route.url.map((url) => url.path));

            // Add an element for the current route part
            if (route.data.breadcrumb) {
                const breadcrumb = {
                    label: this.getLabel(route.data),
                    url: '/' + routeUrl.join('/'),
                };
                breadcrumbs.push(breadcrumb);
            }

            // Add another element for the next route part
            this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
        }
    }

    private getLabel(data: Data) {
        return typeof data.breadcrumb === 'function'
            ? data.breadcrumb(data)
            : data.breadcrumb;
    }
}
